import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DebitData } from "./../models/debitosAutomaticos";
import { RootState } from "./rootReducer";
export type DebitosAutomaticosState = DebitData;

const initialState: DebitosAutomaticosState = {
  debit: {
    debitIdentifiers: [],
    account: null
  }
};

export const DebitosAutomaticos = createSlice({
  name: "DebitosAutomaticosReducer",
  initialState,
  reducers: {
    setDebits: (state, action: PayloadAction<DebitData>) => {
      return { ...state, ...action.payload };
    },
    setDebitosSeleccionados: (state, action: PayloadAction<number[]>) => {
      state.debit.debitIdentifiers = action.payload;
    },
    setCuentaSeleccionada: (state, action: PayloadAction<DebitosAutomaticosState["debit"]["account"]>) => {
      state.debit.account = action.payload;
    }
  }
});

export const { setDebits, setDebitosSeleccionados, setCuentaSeleccionada } = DebitosAutomaticos.actions;

export const getDebitosSeleccionados = (state: RootState) => state.DebitosAutomaticosState.debit.debitIdentifiers;

export const getCuentaSeleccionada = (state: RootState) => state.DebitosAutomaticosState.debit.account;

export default DebitosAutomaticos.reducer;
